import React from 'react';
import EmptyDressCodeCard from './EmptyDressCodeCard';
import PageCard from '../PageCard';
import { PagesQuery, PagesFragment, Wws_Page } from '../../generated/graphql';

type Page = PagesQuery['pages'][0];

interface DressCodePageCardProps {
  page?: Page;
  liteSite: boolean;
  onCreatedPage?: (page: PagesFragment | Wws_Page) => void;
  className?: string;
}

const DressCodePageCard: React.FC<DressCodePageCardProps> = ({ page, liteSite, onCreatedPage }) => {
  const handleCreatedPage = (pageObj: PagesFragment | Wws_Page) => {
    if (typeof pageObj === 'object' && pageObj !== null && (pageObj as any).id) {
      if (onCreatedPage) onCreatedPage(pageObj as PagesFragment & Wws_Page);
    }
  };

  // If we have an actual dress code page, render it as a normal PageCard
  if (page) {
    return <PageCard page={page} liteSite={liteSite} />;
  }

  // Otherwise, show the guidance card (CTA to create one)
  return <EmptyDressCodeCard onCreatedPage={handleCreatedPage} />;
};

export default DressCodePageCard;
